<template>
  <div class="loader-wrapper">
    <div class="loader1">
      <span :style="{ background: $vuetify.theme.themes.light.secondary }"></span>
      <span :style="{ background: $vuetify.theme.themes.light.secondary }"></span>
      <span :style="{ background: $vuetify.theme.themes.light.secondary }"></span>
      <span :style="{ background: $vuetify.theme.themes.light.secondary }"></span>
      <span :style="{ background: $vuetify.theme.themes.light.secondary }"></span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppGlobalSpinner',
}
</script>

<style lang="scss" scoped>
.loader-wrapper {
  position: fixed;
  z-index: 9999;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
}
.loader1 {
  display: inline-block;
  font-size: 0px;
  padding: 0px;
}
.loader1 span {
  vertical-align: middle;
  border-radius: 100%;

  display: inline-block;
  width: 10px;
  height: 10px;
  margin: 3px 2px;
  -webkit-animation: loader1 0.8s linear infinite alternate;
  animation: loader1 0.8s linear infinite alternate;
}
.loader1 span:nth-child(1) {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
  // background: rgba(245, 103, 115, 0.6);
  opacity: 0.6;
}
.loader1 span:nth-child(2) {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
  // background: rgba(245, 103, 115, 0.8);
  opacity: 0.8;
}
.loader1 span:nth-child(3) {
  -webkit-animation-delay: -0.26666s;
  animation-delay: -0.26666s;
  // background: rgba(245, 103, 115, 1);
  opacity: 1;
}
.loader1 span:nth-child(4) {
  -webkit-animation-delay: -0.8s;
  animation-delay: -0.8s;
  // background: rgba(245, 103, 115, 0.8);
  opacity: 0.8;
}
.loader1 span:nth-child(5) {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
  // background: rgba(245, 103, 115, 0.4);
  opacity: 0.4;
}

@keyframes loader1 {
  from {
    transform: scale(0, 0);
  }
  to {
    transform: scale(1, 1);
  }
}
@-webkit-keyframes loader1 {
  from {
    -webkit-transform: scale(0, 0);
  }
  to {
    -webkit-transform: scale(1, 1);
  }
}
</style>
